<template>
  <img src="/images/loading.svg" class="m-auto" />
</template>